export enum PaymentStatus {
None,
Pending,
Dropped,
Completed,
}
